<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[1]" v-text="node.label.split('###')[0]"></span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card ref="right_content" class="box-card" style="width: calc(100% - 290px);">
            <div class="mainBody">
                <div class="dataBox">
                    <h3 class="he-bing-xing-huo-lie">
                        <span class="header-anchor">作业报告</span>
                    </h3>
                    <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                        <div class="el-table__body-wrapper is-scrolling-none">
                            <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                <tbody>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right" width="20%">
                                            <div class="cell"><span>总孔数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.hole_count1}}
                                        </td>
                                        <td class="el-table__cell is-right" width="20%">
                                            <div class="cell"><span>报告总数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count1}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>灌浆报告总段数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.segment_count114}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>灌浆报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count114}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压水总段数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.segment_count13}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压水报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count13}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>封孔报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count15}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <h3 class="he-bing-xing-huo-lie">
                        <span class="header-anchor">监测报告</span>
                    </h3>
                    <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                        <div class="el-table__body-wrapper is-scrolling-none">
                            <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                <tbody>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right" width="20%">
                                            <div class="cell"><span>总孔数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.hole_count2}}
                                        </td>
                                        <td class="el-table__cell is-right" width="20%">
                                            <div class="cell"><span>报告总数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count2}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>灌浆报告总段数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.segment_count214}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>灌浆报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count214}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压水总段数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.segment_count23}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压水报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count23}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>封孔报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" colspan="3" style="padding: 0 10px">
                                            {{countObj.report_count25}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>灌浆异常报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_error_count214}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压水异常报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_error_count23}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>封孔异常报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_error_count25}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>异常报告总数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_error_count29}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <h3 class="he-bing-xing-huo-lie">
                        <span class="header-anchor">抽检报告</span>
                    </h3>
                    <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                        <div class="el-table__body-wrapper is-scrolling-none">
                            <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                <tbody>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right" width="20%">
                                            <div class="cell"><span>总孔数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.hole_count4}}
                                        </td>
                                        <td class="el-table__cell is-right" width="20%">
                                            <div class="cell"><span>报告总数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count4}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>灌浆报告总段数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.segment_count414}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>灌浆报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count414}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压水总段数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.segment_count43}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压水报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_count43}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>封孔报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" colspan="3" style="padding: 0 10px">
                                            {{countObj.report_count45}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>灌浆异常报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_error_count414}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>压水异常报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_error_count43}}
                                        </td>
                                    </tr>
                                    <tr class="el-table__row">
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>封孔异常报告数量：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_error_count45}}
                                        </td>
                                        <td class="el-table__cell is-right">
                                            <div class="cell"><span>异常报告总数：</span></div>
                                        </td>
                                        <td class="el-table__cell" style="padding: 0 10px">
                                            {{countObj.report_error_count49}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
import listutil from "@/libs/listutil"
import { getProjectDivisionTreeData } from '@/api/org'
import { reportCount } from '@/api/statistic'

export default {
    name: 'reportCount',
    mixins: [listutil],
    data() {
        return {
            m_name: '待处置报告',
            menu_id: 6590,
            list_url: "/api/admin/reportdealresult/list",
            search_Obj: {
            },
            del_Obj:{
                url:'/api/admin/workreport1/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            projectDivisionData: [],
            openKeys: [],
            grade: 1,
            pid: 0,
            countObj: {},
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(2).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.current = 1
            this.getReportCount()
        },
        getReportCount(){
            reportCount(this.pid).then(res=>{
                if(res.code == 1){
                    this.countObj = res.data
                }else{
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
</style>